export default {
  namespaced: true,
  policy_exception: {
    title: 'excepción de política | excepciones de política',
    reference_number: 'Número de referencia',
    scope_type: 'Tipo de alcance',
    coverage: 'Cobertura',
    scope: 'Alcance',
    status: 'Estado',
    request_type: 'Tipo de solicitud',
    assigned_to: 'Asignado a',
    in_review: 'En revisión',
    approved_canceled: 'Aprobado/Rechazado',
    request_date: 'Fecha de solicitud',
    start_date: 'Fecha de inicio',
    end_date: 'Fecha de fin',
    regulatory_required: 'Requisito regulatorio',
    regulation_description: 'Descripción de regulación',
    exception_type: 'Tipo de excepción',
    source: 'Origen',
    inherent_risk: 'Riesgo inherente',
    residual_risk: 'Riesgo residual',
    select_exception_type: 'Seleccionar tipo de excepción',
    select_status: 'Seleccionar estado',
    select_source: 'Seleccionar origen',
    select_inherent_risk: 'Seleccionar riesgo inherente',
    select_residual_risk: 'Seleccionar riesgo residual',
    units: 'Inmuebles',
    unit: 'Unidad',
    inmuebles: 'Inmuebles',
    regions: 'Regiones',
    created_from: 'Creado desde',
    created_to: 'Creado hasta',
    validity_from: 'Vigencia desde',
    validity_to: 'Vigencia hasta',
    municipalities: 'Municipios',
    sectors: 'Sectores',
    standards: 'Estándares',
    standards_affected: 'Estándares afectados',
    select_standards: 'Seleccionar estándares',
    description: 'Descripción de la excepción',
    compensatory_measures: 'Medidas compensatorias',
    justification: 'Justificación de la excepción',
    section_detail: 'Detalle sección/subsección del estándar',
    section_attachments: 'Archivos de sección/subsección',
    approver_soeid: 'Aprobador (SOEID)',
    attachments: 'Adjuntar archivos',
    attachments_accepted_types: 'Imágenes, PDF, Word, Excel, ZIP.',
    save_to_view_files: 'Guarda los cambios para visualizar los archivos',
    pending_save: 'pendiente de guardar',
    history: 'Historial',
    history_state: 'Estado',
    history_user: 'Usuario',
    history_date: 'Fecha',
    risk_level_table_level: 'Nivel',
    risk_level_table_description: 'Descripción',
    risk_table_title: 'Tabla de riesgos',
    show_risk_table: 'Mostrar tabla de riesgos',
    risk_level_critical: 'Crítico',
    risk_level_critical_desc: 'Excepciones de incumplimiento de Normas de Seguridad o Riesgos de Seguridad que, tras tener en cuenta los controles compensatorios y factores mitigantes, pueden suponer un riesgo crítico cuando una instalación es vulnerable a un impacto catastrófico en la seguridad/protección o en la operación.',
    risk_level_high: 'Alto',
    risk_level_high_desc: 'Excepciones de incumplimiento de Normas de Seguridad o Riesgos de Seguridad que, tras tener en cuenta los controles compensatorios y factores mitigantes, pueden suponer un riesgo significativo para múltiples instalaciones o procesos, comprometiendo el impacto en seguridad/protección u operativo.',
    risk_level_medium: 'Medio',
    risk_level_medium_desc: 'Excepciones de incumplimiento de Normas de Seguridad o Riesgos de Seguridad que, tras tener en cuenta los controles compensatorios y factores mitigantes, pueden suponer un riesgo moderado para una instalación o proceso; comprometiendo el impacto en seguridad/protección u operativo.',
    risk_level_low: 'Bajo',
    risk_level_low_desc: 'Excepciones de incumplimiento de Normas de Seguridad o Riesgos de Seguridad que, tras tener en cuenta los controles compensatorios y factores mitigantes, podrían tener un efecto adverso insignificante sobre una instalación, su funcionamiento y su personal.',
    status_in_progress: 'En progreso',
    status_in_review: 'En revisión',
    status_approved: 'Aceptado',
    status_rejected: 'Rechazado',
    status_reassigned: 'Reasignado',
    status_canceled: 'Cancelado',
    status_scheduled: 'Programado',
    nacional: 'Nacional',
    select_scope_type: 'Seleccionar tipo de alcance',
    select_request_type: 'Seleccionar tipo de solicitud',
    select_units: 'Seleccionar inmuebles',
    select_municipalities: 'Seleccionar municipios',
    select_sectors: 'Seleccionar sectores',
    select_user: 'Seleccionar usuario',
    select_reviewer: 'Seleccionar revisor',
    select_reviewer_first: 'Selecciona un revisor primero',
    btn_send_to_review: 'Enviar a revisión',
    unable_to_load: 'No se pudo cargar la excepción de política.',
    one_required_field_missing: 'Falta 1 campo obligatorio',
    multiple_required_fields_missing: 'Faltan {count} campos obligatorios',
    last_field: 'Última',
    comments: 'Comentarios',
    comments_placeholder: 'Comentarios opcionales',
    renew_exception: 'Renovar Excepción',
    close_exception: 'Cerrar Excepción',
    change_assignee: 'Cambio de Asignado',
    close_reason: 'Motivo de cierre',
    close_exception_message: 'El formulario quedará solo lectura y la excepción se cerrará.',
    close_reason_placeholder: 'Indique el motivo del cierre',
    start_date_must_be_after_request_date: 'La fecha de inicio debe ser mayor o igual a la fecha de solicitud',
    end_date_must_be_after_start_date: 'La fecha de fin debe ser mayor o igual a la fecha de inicio',
    end_date_must_be_after_request_date: 'La fecha de fin debe ser estrictamente mayor que la fecha de solicitud',
    conflict_inmuebles_in_progress: 'Conflicto de inmuebles',
    conflict_inmueble_in_policy: 'El inmueble {unitLabel} está activo en la excepción de política {referenceNumber} (tipo: {exceptionTypeName}).',
    workflow: {
      submit: 'Enviar',
      approve: 'Aprobar',
      reject: 'Rechazar',
      cancel: 'Cancelar',
      reassign: 'Reasignar',
      submit_title: 'Enviar a revisión',
      approve_title: 'Aprobar excepción',
      reject_title: 'Rechazar excepción',
      cancel_title: 'Cancelar excepción',
      reassign_title: 'Reasignar a usuario',
      confirm_title: 'Confirmar',
      submit_message: '¿Enviar esta excepción a revisión?',
      approve_message: '¿Aprobar esta excepción de política?',
      reject_message: '¿Rechazar esta excepción de política?',
      cancel_message: '¿Cancelar esta excepción de política?',
      confirm_message: '¿Confirmar esta acción para {ref}?',
    },
  },
}
